import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';

export const getPartCountBuckets = (store) => {
  return [
    ...store.partCountBuckets.data.scheduledPartBuckets,
    ...store.partCountBuckets.data.unscheduledPartBuckets,
  ];
};

export const getArePartCountBucketsLoading = (store) => {
  return store.partCountBuckets.loading ? 1 : 0;
};

/**
 * Part Count page–specific loading gate. APM ERP machines do not rely on part
 * count buckets for their display values, so this selector returns false for
 * APM to avoid a permanent loading spinner.
 *
 * Use this selector only on Part Count surfaces (PartCount.js, PartCountTab.js,
 * ProductionPartsDisplay.js). Use getArePartCountBucketsLoading elsewhere (OEE,
 * Cycle Time, Parts Goal, Utilization, etc.).
 */
export const getArePartCountBucketsLoadingForPartCount = (store) => {
  if (getIsApmERPJobFlow(store)) {
    return 0;
  }
  return store.partCountBuckets.loading ? 1 : 0;
};
